exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Spinner__loader___24wT6 {\n  position: relative;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 9999;\n}\n", ""]);

// exports
exports.locals = {
	"loader": "Spinner__loader___24wT6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./src/html-components/Spinner.css
// module id = 1150
// module chunks = 0